import { ChangeDetectorRef, Component, inject, OnInit, signal, ViewContainerRef } from '@angular/core';

import { NgClass, NgTemplateOutlet } from '@angular/common';
import { bannerTransition } from 'src/shared/animations';
import { materialModules } from '../material.module';
import { BannerEvent, BannerMessage } from './banner';
import { BannerService } from './banner.service';

@Component({
  selector: 'ez-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  animations: [bannerTransition],
  imports: [
    materialModules,
    NgClass,
    NgTemplateOutlet,
  ],
})
export class BannerComponent implements OnInit {

  protected readonly message = signal<BannerMessage | null>(null);
  protected readonly componentRef = signal<ViewContainerRef | null>(null);

  readonly #bannerService = inject(BannerService);
  readonly #changeDetectorRef = inject(ChangeDetectorRef);

  constructor() {
    this.#bannerService.asObservable().subscribe(event => this.#handleBannerEvent(event));
  }

  ngOnInit(): void {
    if (this.#bannerService.lastEvent) {
      this.#handleBannerEvent(this.#bannerService.lastEvent);
    }
  }

  protected refresh(): void {
    window.location.reload();
  }

  #handleBannerEvent(event: BannerEvent): void {
    if (event === 'Dismiss') {
      this.#dismiss();
    } else {
      this.#setMessage(event);
    }
  }

  protected dismissBanner(): void {
    this.#bannerService.dismissBanner();
  }

  #dismiss(): void {
    this.message()?.afterDismiss?.();
    this.componentRef()?.clear();
    this.message.set(null);
  }

  #setMessage(message: BannerMessage): void {
    this.message.set(message);
    // The componentRef might not exist yet if the message was previously null.
    // We'll force the change detection so the @if ("message") evaluates to true and creates the componentRef
    this.#changeDetectorRef.detectChanges();

    this.componentRef()?.clear();

    if (this.message()?.componentFactory) {
      const component = this.componentRef()!.createComponent(this.message()!.componentFactory!.factory);
      this.message()!.componentFactory!.afterCreate(component.instance);
    }
  }
}
